"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reducer = void 0;
const fp = require("fp-ts");
const _Reducer = require("../../modules/billingInformation/reducers");
const BasicInformationActionTypes = require("../../actionTypes/bid/basicInformation");
const Reducer = Object.assign({}, _Reducer.default('@sok/bid'));
exports.Reducer = Reducer;
Reducer.methods[BasicInformationActionTypes.BillingActionTypes.FETCH_FETCH_BILLING_INFORMATION_SUCCESS] = (state, action) => {
    return fp.function.compose(Reducer.lenses.statusLens.set('FETCHED'), Reducer.lenses.listLens.set(action.payload))(state);
};
Reducer.methods[BasicInformationActionTypes.INIT] = (state, action) => {
    if (action.payload.bid && action.payload.bid.printOrders.billingInformation) {
        const list = state.list.concat([
            action.payload.bid.printOrders.billingInformation
        ]);
        return Reducer.lenses.listLens.set(list)(state);
    }
    return state;
};
//# sourceMappingURL=billingInformation.js.map